import { ReportPrinter } from '../domain/page';
import Vue from 'vue';

interface ReportApi {
    printReport(batchIndex: number, totalBatches: number): Promise<void>;
    failReport?(reason: string): Promise<void>;
}
declare global {
    interface Window {
        reportApi?: ReportApi;
        __reportFailureNotified?: boolean;
    }
}
export class Vue2ReportPrinter implements ReportPrinter {
    async print(batchIndex: number, totalBatches: number): Promise<void> {
        await Vue.nextTick();
        if (window.reportApi) {
            await window.reportApi.printReport(batchIndex, totalBatches);
        }
    }
}

export function notifyReportFailure(reason: 'data' | 'generation' | 'disabled' | 'render'): void {
    if (window.__reportFailureNotified || !window.reportApi || !window.reportApi.failReport) return;
    window.__reportFailureNotified = true;
    Promise.resolve(window.reportApi.failReport(reason)).catch(() => {
        console.error('Report failure notification could not be delivered');
    });
}
